import Router from 'next/router';
import { Amplify, Hub } from 'aws-amplify';
import { region, userPoolId, userPoolWebClientId } from '../constants';
import getSignInFailureReason from '../utils/getSignInFailureReason';

const setLoginError = (error) => {
  globalThis.setLoginError(error);
  Router.events.off('routeChangeComplete', setLoginError);
};

Hub.listen('auth', (data) => {
  if (data.payload.event === 'signIn_failure') {
    const error = getSignInFailureReason(data.payload.data.message);
    Router.events.on('routeChangeComplete', () => setLoginError(error));
  }
});

const baseUrl =
  typeof window !== 'undefined' && window.location.origin
    ? window.location.origin
    : '';

Amplify.configure({
  Auth: {
    region,
    userPoolId,
    userPoolWebClientId,
    mandatorySignIn: true,
    oauth: {
      domain: 'traciwr.auth.eu-west-2.amazoncognito.com',
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: `${baseUrl}/callback`,
      redirectSignOut: `${baseUrl}/login`,
      responseType: 'code',
    },
  },
  cookieStorage: {
    // - Cookie domain (only required if cookieStorage is provided)
    domain:
      typeof window !== 'undefined' ? window.location.hostname : 'localhost',
    // (optional) - Cookie path
    path: '/',
    // (optional) - Cookie expiration in days
    // expires: 30,
    // (optional) - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
    sameSite: 'strict',
    // (optional) - Cookie secure flag
    // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    secure: process.env.NODE_ENV !== 'development',
  },
  ssr: true,
});
